module.exports = __webpack_public_path__ + "static/media/047-folder.cc794bf5.svg";